import React, { PropsWithChildren, ReactElement } from 'react';
import { Icon } from '../../icons/Icon';
import { WindowPreviewImage } from './WindowPreviewImage';
import styles from './WindowButton.module.scss';

export const WindowButton = ({ children, icon, onClick, chevron }: Props) => (
    <div className={styles.container} onClick={onClick}>
        {icon && (
            <WindowPreviewImage>{icon}</WindowPreviewImage>
        )}

        {children}

        {chevron && (
            <div className={styles.chevron}>
                <Icon type='general-ui-chevrons-right' />
            </div>
        )}
    </div>
);

type Props = PropsWithChildren<{
    icon?: ReactElement;
    onClick: () => void;
    chevron?: boolean;
}>;